module.exports = __webpack_public_path__ + "media/images/shark/SharkCafeMap-84b5762370565fe327dd437aac54c1a0.jpg";